<script lang="ts">
  import type { SkillCategory, SkillCategorySummary } from '$lib/api/types';

  interface Props {
    skillCat: SkillCategory;
    progress?: number;
  }

  let { skillCat, progress }: Props = $props();
</script>

<div class="category">
  <img
    src={skillCat.badge}
    class="skill-badge"
    class:incomplete={(progress ?? 0) < skillCat.skills.length}
    alt="badge for skill category {skillCat.name}"
  />
  <h5 class="category-header">{skillCat.name}</h5>
  <div>
    {(progress ?? 0)}/{skillCat.skills.length}
  </div>
</div>

<style>
  .category {
    text-align: center;
  }

  .category-header {
    font-size: 1em;
    margin-top: 1rem;
  }

  .skill-badge {
    width: 128px;
    height: 128px;
    display: block;
  }

  .skill-badge.incomplete {
    filter: grayscale();
  }
</style>
